import { render, staticRenderFns } from "./CommonItem.vue?vue&type=template&id=35c24928&scoped=true"
import script from "./CommonItem.vue?vue&type=script&lang=js"
export * from "./CommonItem.vue?vue&type=script&lang=js"
import style0 from "./CommonItem.vue?vue&type=style&index=0&id=35c24928&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c24928",
  null
  
)

export default component.exports